import { useCallback } from "react";
import { useTranslation } from "@ncp/i18n";
import { useConfirm } from "@ncp/ui";

export type ConfirmKey = "finaliseReport" | "issueDecision" | "notifyParties" | "shareReport" | "preNotification" | "publish" | "enforcementIssue" | "sendLetter" | "mergeRecords" | "finalNotice";

/** Runs an irreversible action only once the officer has confirmed it, in the wording of `backoffice:confirm.<key>`. */
export function useConfirmAction(): (key: ConfirmKey, run: () => void) => Promise<void> {
  const confirm = useConfirm();
  const { t } = useTranslation();
  return useCallback(
    async (key, run) => {
      const ok = await confirm({
        title: t(`backoffice:confirm.${key}.title`),
        description: t(`backoffice:confirm.${key}.body`),
        confirmLabel: t(`backoffice:confirm.${key}.action`),
      });
      if (ok) run();
    },
    [confirm, t],
  );
}
